module.exports = __webpack_public_path__ + "static/media/dark@2x.fe67d9cf.png";